module.exports = __webpack_public_path__ + "static/media/smartphone.96180b21.png";